export const messages = {
  'MENU.DASHBOARD': 'Bảng điều khiển',
  'MENU.USERS': 'Người dùng',
  'MENU.SETTINGS': 'Cài đặt',
  'MENU.PROFILE': 'Hồ sơ',
  'MENU.LOGOUT': 'Đăng xuất',
  'COMMON.SAVE': 'Lưu',
  'COMMON.CANCEL': 'Hủy',
  'COMMON.DELETE': 'Xóa',
  'COMMON.EDIT': 'Sửa',
  'COMMON.ADD': 'Thêm',
  'COMMON.SEARCH': 'Tìm kiếm',
  'COMMON.LOADING': 'Đang tải...',
  'COMMON.ERROR': 'Lỗi',
  'COMMON.SUCCESS': 'Thành công',
  'COMMON.WARNING': 'Cảnh báo',
  'COMMON.INFO': 'Thông tin',
  'AUTH.LOGIN': 'Đăng nhập',
  'AUTH.LOGOUT': 'Đăng xuất',
  'AUTH.REGISTER': 'Đăng ký',
  'AUTH.FORGOT_PASSWORD': 'Quên mật khẩu',
  'AUTH.EMAIL': 'Email',
  'AUTH.PASSWORD': 'Mật khẩu',
  'AUTH.REMEMBER_ME': 'Duy trì đăng nhập',
  'AUTH.LOGIN_ERROR': 'Thông tin đăng nhập không chính xác',
  'DASHBOARD.WELCOME': 'Chào mừng bạn đến với hệ thống',
  'DASHBOARD.STATS': 'Thống kê',
  'DASHBOARD.RECENT_ACTIVITY': 'Hoạt động gần đây',
  'DASHBOARD.QUICK_ACTIONS': 'Thao tác nhanh',
} 